import {
  GetAllAvailableOrganizationsRequiredTagsEnum,
  GetAllPostsByAppVariantAndSelectedGeoAreasSortByEnum
} from '@DigitaleDoerfer/digitale-doerfer-api';
import { useEffect, type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useGetAllPostsBySelectedGeoAreas } from '@/features/api/hooks/grapevine-post/useGetAllPostsBySelectedGeoAreas';
import { SimplePostList } from '@/features/posts/components/SimplePostList';
import { useGetPostsParams } from '@/features/posts/hooks/useGetPostsParams';
import { PostFeedType } from '@/features/posts/types/postFeed';
import { StartRoute } from '@/features/start/navigation/startRoute';
import { LocalizationNameSpace } from '@/localization/types/localizationTypes';
import type {
  AppNativeStackScreenProps,
  AppRoute
} from '@/navigation/types/navigation';

type Props = AppNativeStackScreenProps<typeof AppRoute.CivilProtection>;

export const CivilProtectionScreen: FC<Props> = ({ navigation }) => {
  const { t } = useTranslation(LocalizationNameSpace.START, {
    keyPrefix: 'routes'
  });

  // Katwarn deliberately stays global: not restricted to the explicitly
  // selected geo areas (onlyExplicitlySelectedGeoAreas: false).
  const civilProtectionParams = useGetPostsParams(
    PostFeedType.CIVIL_PROTECTION,
    {
      onlyExplicitlySelectedGeoAreas: false,
      sortBy: GetAllPostsByAppVariantAndSelectedGeoAreasSortByEnum.Created,
      requiredOrganizationTags: [
        GetAllAvailableOrganizationsRequiredTagsEnum.CivilProtection
      ]
    }
  );

  const {
    data: posts,
    isLoading,
    isError,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    refetch,
    isRefetching
  } = useGetAllPostsBySelectedGeoAreas(civilProtectionParams);

  useEffect(() => {
    if (isFetching) return;
    navigation.setOptions({
      title: t(StartRoute.CivilProtection, { count: posts?.length ?? 0 })
    });
  }, [isFetching, navigation, posts?.length, t]);

  return (
    <SimplePostList
      posts={posts}
      isLoading={isLoading}
      isError={isError}
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      isFetching={isFetching}
      isFetchingNextPage={isFetchingNextPage}
      refetch={refetch}
      isRefetching={isRefetching}
      hideEndView
      hidePostType
    />
  );
};
